import LearningModule from '@/classes/learningModule';

const state = () => ({
  learningModules: {},
  outlines: {},
});

const getters = {
  all: (state) => Object.keys(state.learningModules).map(key => state.learningModules[key]),
  get: (state) => state.learningModules,
  outline: (state) => state.outlines,
};

const mutations = {
  set: function(state, learningModules) {
    learningModules.forEach(learningModule => {
      state.learningModules[learningModule.id] = learningModule;
    });
  },
  setOutline: function(state, { outline, learningModuleId }) {
    state.outlines[learningModuleId] = outline;
  },
  reset: function(state) {
    state.learningModules = {};
    state.outlines = {};
  },
};

const actions = {
  fetch({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/learning_modules', { params }).then(({ data }) => {
      const module = new LearningModule(data.learningModule);
      commit('set', [module]);
      return module;
    });
  },
  fetchAll({ dispatch, commit, getters, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/learning_modules', { params }).then(({ data }) => {
      const modules = data.learningModules.map(lm => new LearningModule(lm));
      commit('set', modules);
    });
  },
  reset({ dispatch, commit, getters, rootGetters }, assetAssociationIds) {
    commit('assetAssociationStates/delete', assetAssociationIds, { root: true });
    commit('flashcardStates/deleteFlashcardStates', { type: 'Asset Association', assetAssociationIds }, { root: true });

    return rootGetters['session/ajax'].post('/learning_modules/reset', { assetAssociationIds });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
